import { ErrorHandler, NgModule } from '@angular/core';
import { HotjarService } from './hotjar/hotjar.service';
import { IntercomService } from './intercom/intercom.service';
import { SentryInitializer } from './sentry/sentry.factory';
import * as Sentry from '@sentry/angular-ivy';
import { UsersnapService } from './usersnap/usersnap.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [
        HotjarService,
        IntercomService,
        UsersnapService,
        SentryInitializer.init(),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false
            }),
        }
    ]
})
export class ExternalAppServices {}
